import React from 'react';
import './FeedbackPage.css';

const FeedbackPage = () => {
  return (
    <div className="feedback-page">
      <div className="feedback-container">
        <div className="feedback-form-wrapper">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLScS6ywKbJQDW4280ZCB2VyNnXafJyhKC9ndaH3gq9MiqwszKA/viewform?embedded=true"
            title="Feedback Form"
            width="640"
            height="830"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
          >
            Loading…
          </iframe>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPage;
